"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M9 4.5815C6.0682 5.7683 4 8.6426 4 12c0 4.4183 3.5817 8 8 8s8-3.5817 8-8c0-3.3033-2.0021-6.139-4.8591-7.3598v2.2466C16.8563 7.9428 18 9.8378 18 12c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6c0-2.2208 1.2066-4.1598 3-5.1973V4.5815z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12V3h2v9h-2z"
  })];
};

exports.default = _default;